module.exports = __webpack_public_path__ + "img/f4f46df.jpg";